module.exports = __webpack_public_path__ + "static/img/sand_11_mini2.28c6065f.png";